var map = {
	"./btn_parents_01_blog.png": 216,
	"./btn_parents_02_parentstis.png": 1199,
	"./btn_parents_03_blog_video.png": 1200,
	"./btn_parents_04_blog_video-POPA.png": 1201,
	"./btn_parents_05_training_workshop.png": 1202,
	"./btn_parents_06_more_resources_on_parenting.png": 1203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1198;